
import MHeader from '../Header/Header.vue';
import Calendar from './Calendar';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import {
getSignIn,
dosign,
wxConfigAjax
} from '../../api';
export default {
components: {
MHeader,
Calendar,
XDialog
},
directives: {
TransferDom
},
data() {
return {
nowDay: "-1",
signText: "签到",
siginList: [],
getNum: "",
res: "",
show: false
}
},
methods: {
signBtn() {
if (this.signText == "已签到") return;
this.$store.commit('showIsLoading');
dosign().then(res => {
if (res.data.error_code) {
console.error(res);
alert(res.data.msg);
return;
};
this.signText = "已签到"
var date = new Date();
this.nowDay = date.getDate();
this.getNum = res.data.coinCount;
this.qiandao();
});
},
qiandao() {
this.$store.commit('showIsLoading');
getSignIn().then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
console.log(res);
this.res = res.data;
var arr = [];
if (!res.data.data) {
return;
};
for (let i = 0; i < res.data.data.length; i++) {
arr.push(Math.abs(res.data.data[i].substr(-2)));
};
this.siginList = arr;
let date = new Date();
let nowDate = date.getDate();
this.signText = arr.indexOf(nowDate) == "-1" ? "签到" : "已签到";
this.getNum = this.signText == "已签到" ? res.data.count : "";

})
},
back() {
this.$router.push({
name: 'home'
});


}
},
created() {
this.qiandao();
wxConfigAjax({
title: '快买酒签到',
desc: '快买酒签到',
url: `home/signIn/%E7%AD%BE%E5%88%B0`
});
}
};



// WEBPACK FOOTER //
// ./src/components/HomeSignIn/HomeSignIn.vue